import http from '../../../../../../libs/http'
import calidad from '../../../../../../config/calidad'
export default (filePath) => http.getUri({
  url: `${calidad.host}/documentos/descargar/${filePath}`
})
